<template lang="pug">
.page
    .layout
        .left-panel
            .ctl-bar
                a-button(type="primary" @click="handleCreateGroup" style="margin-right:12px")
                    a-icon(type="plus")
                    span 新建 Group
                a-button(type="primary" @click="refreshData" style="margin-right:12px")
                    a-icon(type="redo")
                    span 刷新
                a-button(type="default" @click="clearSelectedGroup" v-if="selectedGroup")
                    a-icon(type="close")
                    span 取消选择

            a-table(:columns="groupColumns"
                :dataSource="groups"
                :pagination="{ pageSize: 20 }"
                size="small"
                rowKey="_id"
                :rowClassName="rowClassName"
                :customRow="customRow")
                template(slot="accountCount" slot-scope="text, record")
                    span {{ record.accounts ? record.accounts.length : 0 }}
                template(slot="action" slot-scope="record")
                    a(@click.stop="handleEditGroup(record)" style="margin-right:8px")
                        a-icon(type="edit")
                    a-popconfirm(title="确认删除该 Group 吗？" ok-text="确认" cancel-text="取消" @confirm="submitDeleteGroup(record._id)")
                        a.red
                            a-icon(type="delete")

        .right-panel
            .account-header
                h3 {{ selectedGroup ? `Group: ${selectedGroup.name} 的账户` : '全部账户' }}
                a-button(type="primary" @click="handleAddAccount" :disabled="!selectedGroup" size="small")
                    a-icon(type="plus")
                    span 添加到 group

            a-table(:columns="accountColumns"
                :dataSource="displayedAccounts"
                :pagination="{ pageSize: 20 }"
                size="small"
                rowKey="_id")
                template(slot="name" slot-scope="text, record")
                    a(@click="go(record)") {{ text }}
                template(slot="remove" slot-scope="record")
                    a-popconfirm(title="确认从该 Group 移除此账户？" ok-text="确认" cancel-text="取消" @confirm="handleRemoveAccount(record._id)")
                        a.red
                            a-icon(type="minus-circle")
                            span 移除

    //- 新建 Group Modal
    a-modal(v-model="addGroupVisible" title="新建 Group" @ok="submitCreateGroup" ok-text="创建" cancel-text="取消")
        a-form-model(:model="groupForm" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }")
            a-form-model-item(label="名称")
                a-input(v-model="groupForm.name" placeholder="Group 名称")
            a-form-model-item(label="描述")
                a-input(v-model="groupForm.desc" placeholder="描述信息")

    //- 编辑 Group Drawer
    a-drawer(:visible="editGroupVisible" title="编辑 Group" width="400" @close="editGroupVisible = false")
        a-form-model(:model="editGroupForm" layout="vertical")
            a-form-model-item(label="名称")
                a-input(v-model="editGroupForm.name")
            a-form-model-item(label="描述")
                a-input(v-model="editGroupForm.desc")
        .submit-panel
            a-button(type="primary" @click="submitEditGroup") 保存修改

    //- 添加账户 Drawer
    a-drawer(:visible="addAccountVisible" title="添加账户到 Group" width="840" @close="addAccountVisible = false")
        a-transfer(:dataSource="transferDataSource" :targetKeys="accountAddForm.accountIds" @change="handleTransferChange" :render="renderTransferItem" :titles="['未选中账户', '已选中账户']" :list-style="{ width: '360px', height: '700px' }" :show-select-all="true")
        .submit-panel
            a-button(type="primary" @click="submitAddAccounts") 添加
</template>

<script>
import { mapState } from 'vuex';
export default {
    data() {
        return {
            groups: [],
            accounts: [],
            selectedGroup: null,

            groupColumns: [
                { title: '名称', dataIndex: 'name' },
                { title: '描述', dataIndex: 'desc' },
                { title: '账户数', scopedSlots: { customRender: 'accountCount' } },
                { title: '操作', scopedSlots: { customRender: 'action' } },
            ],


            addGroupVisible: false,
            groupForm: { name: '', desc: '' },

            editGroupVisible: false,
            editGroupForm: { _id: '', name: '', desc: '' },

            addAccountVisible: false,
            accountAddForm: { accountIds: [] },
        }
    },
    computed: {
        displayedAccounts() {
            if (this.selectedGroup) {
                const groupAccountIds = new Set((this.selectedGroup.accounts || []).map(a => typeof a === 'string' ? a : a._id));
                return this.accounts.filter(a => groupAccountIds.has(a._id));
            }
            return this.accounts;
        },
        availableAccounts() {
            if (!this.selectedGroup) return [];
            const existingIds = new Set((this.selectedGroup.accounts || []).map(a => typeof a === 'string' ? a : a._id));
            return this.accounts.filter(acc => !existingIds.has(acc._id));
        },
        accountColumns() {
            const cols = [
                { title: '名称', dataIndex: 'name', scopedSlots: { customRender: 'name' } },
            ];

            // 非测试用户显示Account和Broker列
            const testUsers = ['risk_review01', 'option_risk_c'];
            if (!testUsers.includes(this.me?.name)) {
                cols.push(
                    { title: 'Account', dataIndex: 'account' },
                    { title: 'Broker', dataIndex: 'broker' }
                );
            }

            cols.push(
                { title: '账户类型', dataIndex: 'accountType' },
                { title: '描述', dataIndex: 'desc' },
            );

            if (this.selectedGroup) {
                cols.push({ title: '操作', scopedSlots: { customRender: 'remove' } });
            }
            return cols;
        },
        transferDataSource() {
            return this.availableAccounts.map(acc => ({
                key: acc._id,
                title: acc.name,
                description: acc.accountType,
            }));
        },
        ...mapState('user', ['me'])
    },
    mounted() {
        this.refreshData();
    },
    methods: {
        rowClassName(record) {
            return this.selectedGroup && this.selectedGroup._id === record._id ? 'selected-row' : '';
        },
        customRow(record) {
            return {
                on: {
                    click: () => {
                        this.handleGroupRowClick(record);
                    }
                }
            };
        },
        refreshData() {
            this.getAccounts();
            this.getGroups();
        },
        handleTransferChange(nextTargetKeys) {
            this.accountAddForm.accountIds = nextTargetKeys;
        },
        renderTransferItem(item) {
            return item.title + ' (' + item.description + ')';
        },
        getAccounts() {
            this.$api.request('GET', 'tradeAccount/user')
                .then(res => {
                    this.accounts = res.data;
                })
                .catch(() => {
                    this.$message.error('获取账户失败');
                });
        },
        getGroups() {
            this.$api.request('GET', 'tradeAccount/user/groups')
                .then(res => {
                    const prevId = this.selectedGroup ? this.selectedGroup._id : null;
                    this.groups = res.data;
                    if (prevId) {
                        const updated = this.groups.find(g => g._id === prevId);
                        this.selectedGroup = updated || null;
                    }
                })
                .catch(() => {
                    this.$message.error('获取 Group 失败');
                });
        },
        handleGroupRowClick(record) {
            if (this.selectedGroup && this.selectedGroup._id === record._id) {
                this.selectedGroup = null;
            } else {
                this.selectedGroup = record;
            }
        },
        handleCreateGroup() {
            this.groupForm = { name: '', desc: '' };
            this.addGroupVisible = true;
        },
        submitCreateGroup() {
            if (!this.groupForm.name || !this.groupForm.name.trim()) {
                this.$message.error('Group 名称不能为空');
                return;
            }
            this.$api.request('POST', 'tradeAccount/user/group/create', {
                name: this.groupForm.name.trim(),
                desc: this.groupForm.desc.trim(),
            })
                .then(() => {
                    this.$message.success('创建成功');
                    this.addGroupVisible = false;
                    this.getGroups();
                })
                .catch(e => {
                    const msg = e.response && e.response.data ? e.response.data : '创建失败';
                    this.$message.error(msg);
                });
        },
        handleEditGroup(record) {
            this.editGroupForm = { _id: record._id, name: record.name, desc: record.desc || '' };
            this.editGroupVisible = true;
        },
        submitEditGroup() {
            if (!this.editGroupForm.name || !this.editGroupForm.name.trim()) {
                this.$message.error('Group 名称不能为空');
                return;
            }
            this.$api.request('POST', 'tradeAccount/user/group/update', {
                _id: this.editGroupForm._id,
                name: this.editGroupForm.name.trim(),
                desc: this.editGroupForm.desc.trim(),
            })
                .then(() => {
                    this.$message.success('更新成功');
                    this.editGroupVisible = false;
                    this.getGroups();
                })
                .catch(e => {
                    const msg = e.response && e.response.data ? e.response.data : '更新失败';
                    this.$message.error(msg);
                });
        },
        submitDeleteGroup(id) {
            this.$api.request('DELETE', `tradeAccount/user/group/${id}`)
                .then(() => {
                    this.$message.success('删除成功');
                    if (this.selectedGroup && this.selectedGroup._id === id) {
                        this.selectedGroup = null;
                    }
                    this.getGroups();
                })
                .catch(e => {
                    const msg = e.response && e.response.data ? e.response.data : '删除失败';
                    this.$message.error(msg);
                });
        },
        handleAddAccount() {
            if (!this.selectedGroup) return;
            this.accountAddForm.accountIds = [];
            this.addAccountVisible = true;
        },
        submitAddAccounts() {
            if (!this.selectedGroup) return;
            const ids = this.accountAddForm.accountIds;
            if (!ids || ids.length === 0) {
                this.$message.error('请至少选择一个账户');
                return;
            }
            const groupId = this.selectedGroup._id;
            const promises = ids.map(accountId => {
                return this.$api.request('POST', `tradeAccount/user/group/${groupId}/add-account`, { accountId });
            });
            Promise.all(promises)
                .then(() => {
                    this.$message.success('添加成功');
                    this.addAccountVisible = false;
                    this.getGroups();
                })
                .catch(e => {
                    const msg = e.response && e.response.data ? e.response.data : '添加失败';
                    this.$message.error(msg);
                    this.getGroups();
                });
        },
        handleRemoveAccount(accountId) {
            if (!this.selectedGroup) return;
            const groupId = this.selectedGroup._id;
            this.$api.request('POST', `tradeAccount/user/group/${groupId}/remove-account`, { accountId })
                .then(() => {
                    this.$message.success('移除成功');
                    this.getGroups();
                })
                .catch(e => {
                    const msg = e.response && e.response.data ? e.response.data : '移除失败';
                    this.$message.error(msg);
                });
        },
        clearSelectedGroup() {
            this.selectedGroup = null;
        },
        go(record) {
            window.open(`/trade/index.html#${record._id}`, '_blank');
        },
    }
}
</script>

<style lang="less" scoped>
.layout {
    display: flex;
    gap: 16px;
}

.left-panel {
    flex: 0 0 40%;
    max-width: 600px;
}

.right-panel {
    flex: 1;
    min-width: 0;
}

.ctl-bar {
    margin-bottom: 12px;
}

.account-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;

    h3 {
        margin: 0;
        font-size: 16px;
    }
}

.red {
    color: red;
}

.submit-panel {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 100%;
    border-top: 1px solid #e9e9e9;
    padding: 10px 16px;
    background: #fff;
    text-align: right;
    z-index: 1;
}
</style>

<style lang="less">
.selected-row {
    background-color: #73b2fa !important;
}
</style>
